'use client';

import Image from 'next/image';

import { translate } from '@openclassrooms/translations';

import { styled } from '@classify/react-core-components/styles';
import Stack from '@classify/react-core-components/Stack';
import Typography from '@classify/react-core-components/Typography';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
import Section from '@classify/react-core-components/Section';

import ManonSrc from './images/Manon.png';
import CamilleSrc from './images/Camille.png';
import HafidSrc from './images/Hafid.png';
import AliceSrc from './images/Alice.png';

const PersonasWrapper = styled(Stack)({
  maxWidth: 960,
  margin: 'auto',
});

const IntroWrapper = styled(Stack)(({ theme: { spacing } }) => ({
  textAlign: 'center',
  marginBottom: spacing(3),
}));

const Persona = styled(Stack)({
  flexShrink: 1,
  flexGrow: 1,
  flexBasis: '45%',
});

const IntroTestimonials = () => {
  const testimonials = [
    {
      pictureUrl: ManonSrc,
      studentName: translate('student_experience.students.student1.name_age'),
      studentProfession: translate('student_experience.students.student1.profession'),
    },
    {
      pictureUrl: CamilleSrc,
      studentName: translate('student_experience.students.student2.name_age'),
      studentProfession: translate('student_experience.students.student2.profession'),
    },
    {
      pictureUrl: HafidSrc,
      studentName: translate('student_experience.students.student3.name_age'),
      studentProfession: translate('student_experience.students.student3.profession'),
    },
    {
      pictureUrl: AliceSrc,
      studentName: translate('student_experience.students.student4.name_age'),
      studentProfession: translate('student_experience.students.student4.profession'),
    },
  ];

  return (
    <Section>
      <ContentWrapper>
        <IntroWrapper>
          <Typography variant="h2">{translate('student_experience.students.title')}</Typography>
          <Typography component="p" variant="subheading">
            {translate('student_experience.students.text')}
          </Typography>
        </IntroWrapper>
        <PersonasWrapper
          direction="row"
          justifyContent={{ xs: 'center', md: 'space-evenly' }}
          gap={4}
          flexWrap={{ xs: 'wrap', md: 'nowrap' }}
        >
          {testimonials.map(({ pictureUrl, studentName, studentProfession }) => (
            <Persona key={studentName} gap={2} alignItems="center" justifyContent="center">
              <Image src={pictureUrl} alt="" width={80} height={80} />
              <div>
                <Typography component="p" variant="h6" textAlign="center">
                  {studentName}
                </Typography>
                <Typography component="p" variant="subheadingSmall" textAlign="center">
                  {studentProfession}
                </Typography>
              </div>
            </Persona>
          ))}
        </PersonasWrapper>
      </ContentWrapper>
    </Section>
  );
};

export default IntroTestimonials;
